module.exports = "/assets/dac873c837ca1bd05e460dbd344220d0.png";